import { graphql } from '@api/gql';

export const integrationResourcesQueryDocument = graphql(/* GraphQL */ `
  query IntegrationResources($id: String!) {
    integrationResources(id: $id) {
      edges {
        node {
          id
          name
          owners {
            attributeValue {
              id
              name
              typDisplayName
              type
            }
            integration {
              icons {
                svg
                png
              }
              id
              name
              type
              typeDisplayName
            }
          }
          path {
            key
            keyDisplayName
            value
          }
          status {
            message
            status
          }
          tags {
            key
            value
          }
          type {
            icons {
              svg
            }
            type
            typeDisplayName
          }
        }
      }
    }
  }
`);
